// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAmf3H30y2ljskToNr8VbRYtjh8024QFAo",
  authDomain: "agenda-sincro.firebaseapp.com",
  projectId: "agenda-sincro",
  storageBucket: "agenda-sincro.firebasestorage.app",
  messagingSenderId: "269469678424",
  appId: "1:269469678424:web:91d4d83e69a135a920432d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);